import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentPageHeader, ExtraHeaderPage } from '../../molecules/page-header/ContentPageHeader';
import { HOME } from '../../../constants/define/translation';
// import { IconCreateBlack, IconPublish } from '../../../assets';
import { IconCreateBlack } from '../../../assets';

interface HomeTilesPageHeaderProps {
  onOpenHomeTilesModal?: () => void;
}

export const HomeTilesPageHeader = (props: HomeTilesPageHeaderProps) => {
  const { t } = useTranslation(HOME);
  const { onOpenHomeTilesModal } = props;

  const extra: ExtraHeaderPage[] = [
    {
      key: 1,
      text: t('header.buttonCreate'),
      bgWhite: 'true',
      onClick: onOpenHomeTilesModal,
      icon: <IconCreateBlack />,
    },
    // { key: 2, text: t('header.buttonPublish'), icon: <IconPublish /> },
  ];

  return <ContentPageHeader title={t('header.titleTiles')} extra={extra} />;
};
